import { useEffect, useState } from "react";
import PageTemplate from "../../Templates/PageTemplate";
import "./ShowProfile.css"
import middleware from "../../Api/Middleware";
import Cookies from "universal-cookie";
import { ButtonBlue } from "../../HouseStyle/Components/Buttons";
import { useNavigate } from "react-router";
import { BackButton } from "../../HouseStyle/Components/Buttons";

const ShowProfile = () => {
    const navigate = useNavigate();
    const cookies = new Cookies;
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState([]);
    const [language, setlanguage] = useState("");

    const fetchAll = async () => {
        try {
            setLoading(true);
            const [fetchUserRes, pfpRes] = await Promise.all([
                middleware.get(`users?api_token=${cookies.get("token")}`),
                middleware.get(`profilepicture`),
            ]);

            const userData = {
                ...fetchUserRes.data.data[0],
                profile_picture: pfpRes.data.profile_picture_url,
            };
            setUser(userData);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        fetchAll();
    }, []);

    useEffect(() => {
        setlanguage(parseLanguage());
    }, [user]);

    const parseLanguage = () => {
        if (user.language === "NL") {
            return "Nederlands";
        } else if (user.language === "EN") {
            return "Engels";
        } else if (user.language === "DE") {
            return "Duits";
        } else if (user.language === "FR") {
            return "Frans";
        }
    }

    return (
        <PageTemplate navbarTitle={"Mijn profiel"} pageIsLoading={loading} backValue={-1}>
            <div className="d-flex flex-column gap-4 w-100">
                <div className="d-flex justify-content-between">
                    <BackButton text={"Terug"} disabled={false} onClickFunction={() => navigate("/")} />
                    <ButtonBlue text={"Profiel bewerken"} onClickFunction={() => navigate("/profiel/bewerken")} />
                </div>
                <div className="d-flex flex-row gap-4">
                    <div className="d-flex flex-column p-4 whiteBox w-100">
                        <h4 className="text-subTitle">Algemene gegevens</h4>
                        <div className="innerBox d-flex flex-column gap-2">
                            <div className="infoData">
                                <div>Voornaam</div>
                                <div>{user.first_name}</div>
                                <div>Achternaam</div>
                                <div>{user.last_name}</div>
                                <div>Taal</div>
                                <div>{language}</div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center justify-content-center p-4 whiteBox" style={{ minWidth: 220, maxWidth: 260 }}>
                        <h4 className="text-subTitle">Profielfoto</h4>
                        <div className="editProfilePicture m-0 d-flex justify-content-center">
                            <img
                                src={user.profile_picture || require("../nopfp.png")}
                                alt="Profilepicture"
                                style={{ width: 120, height: 120, objectFit: "cover", borderRadius: "50%", border: "2px solid #eee" }}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column justify-content-between p-4 w-100 whiteBox mt-2">
                    <h4 className="text-subTitle">Contactinformatie</h4>
                    <div className="innerBox">
                        <div className="infoData">
                            <div>E-mail</div>
                            <div>{user.email}</div>
                        </div>
                    </div>
                </div>
            </div>
        </PageTemplate>
    )
}

export default ShowProfile;